export const openingHours = [
  { day: 'monday', open: null, close: null, closed: true },
  { day: 'tuesday', open: '12:00', close: '23:00', closed: false },
  { day: 'wednesday', open: '12:00', close: '23:00', closed: false },
  { day: 'thursday', open: '12:00', close: '23:00', closed: false },
  { day: 'friday', open: '12:00', close: '23:00', closed: false },
  { day: 'saturday', open: '12:00', close: '23:00', closed: false },
  { day: 'sunday', open: '12:00', close: '22:00', closed: false }
];

export const isCurrentlyOpen = () => {
  const now = new Date();
  const dayIndex = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const today = openingHours.find(h => h.day === days[dayIndex]);

  if (!today || today.closed) return false;

  const currentTime = now.getHours() * 60 + now.getMinutes();
  const [openHour, openMin] = today.open.split(':').map(Number);
  const [closeHour, closeMin] = today.close.split(':').map(Number);

  const openTime = openHour * 60 + openMin;
  const closeTime = closeHour * 60 + closeMin;

  return currentTime >= openTime && currentTime < closeTime;
};

export const getFormattedHours = (language = 'de') => {
  const dayNames = {
    de: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag'
    },
    en: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    }
  };

  const closedText = language === 'de' ? 'Ruhetag' : 'Closed';

  return openingHours.map(h => ({
    day: dayNames[language][h.day],
    hours: h.closed ? closedText : `${h.open} - ${h.close}`,
    closed: h.closed
  }));
};

export const reservationTimes = [
  '12:00', '12:30', '13:00', '13:30', '14:00',
  '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00'
];
